import React from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import readXlsxFile from 'read-excel-file';
import Modal from 'react-bootstrap/Modal';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

class ImportExport extends React.Component {
    _isMounted = false;
    state = {
        alert: 0,
        alertMessage: '',
        flag: false,
        LastUpdatedTimeStamp: '',
        UpdatedBy: '',
        RequestedTimeStamp: '',
        StoreOwners: [],
        storeFileUplaoded: false,
        WhatsappAlertChecked: false
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
    }

    DownloadTemplate = () => {
        window.open('/SampleStoreOwners.xlsx');
    };

    handleFileUploaded = async (event) => {
        let mapRecords = [];
        if (event.target.files.length > 0) {
            if (this._isMounted) {
                this.setState({ flag: true });
            }
            this.file = event.target.files[0];
            await readXlsxFile(this.file, { getSheets: true })
                .then(async (sheets) => {
                    await sheets.forEach(async (value) => {
                        await readXlsxFile(this.file, {
                            sheet: value.name
                        }).then(async (sheetdata) => {
                            await sheetdata.forEach(async (sheetvalue) => {
                                if (sheetvalue[0] !== 'Tag') {
                                    mapRecords.push({
                                        StoreTag: sheetvalue[0],
                                        FullName: sheetvalue[1],
                                        PhoneNumber: sheetvalue[2],
                                        PanNumber: sheetvalue[3],
                                        Area: sheetvalue[4],
                                        City: sheetvalue[5],
                                        District: sheetvalue[6],
                                        HouseNumber: sheetvalue[7],
                                        State: sheetvalue[8],
                                        PinCode: sheetvalue[9],
                                        AadharNumber: sheetvalue[10],
                                        DateOfBirth: sheetvalue[11],
                                        AccountHolderName: sheetvalue[12],
                                        AccountType: sheetvalue[13],
                                        BankName: sheetvalue[14],
                                        IFSCCode: sheetvalue[15],
                                        AccountNumber: sheetvalue[16],
                                        Status: 'Approved',
                                        Profession: '',
                                        Address: '',
                                        EmailId: '',
                                        Education: '',
                                        SecondaryPhoneNumber: '',
                                        WhatsAppNumber: sheetvalue[2],
                                        RegionalLanguage: '',
                                        Roles: 'StoreOwners',
                                        StoreType: '',
                                        RequestedTimeStamp: dateFormatUtil(),
                                        LastUpdatedTimeStamp: dateFormatUtil(),
                                        UpdatedBy: this.props.user.FullName
                                    });
                                }
                            });
                        });
                    });
                    if (this._isMounted) {
                        this.setState({
                            storeFileUplaoded: true,
                            flag: false,
                            StoreOwners: mapRecords
                        });
                    }
                })
                .catch(function (error) {});
        }
    };

    uplaodData = async (event) => {
        let data = {
            StoreOwnersList: this.state.StoreOwners,
            WhatsappAlertChecked: this.state.WhatsappAlertChecked
        };

        this.setState({ flag: true, alert: 0, alertMessage: '' });
        

        await RestServices.bulkImportStoreOwners(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.status) {
                    if (responseData.warningStoreOwners.length > 0) {
                        this.setState({
                            flag: false,
                            StoreOwners: responseData.warningStoreOwners,
                            alert: 3,
                            alertMessage: responseData.warningMessage
                        });
                    } else {
                        this.setState({
                            storeFileUplaoded: false,
                            flag: false,
                            alert: 2,
                            alertMessage: responseData.message
                        });
                    }
                } else {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: responseData.message
                    });
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    forceuplaodData = async (event) => {
        let data = {
            StoreOwnersList: this.state.StoreOwners,
            WhatsappAlertChecked: this.state.WhatsappAlertChecked
        };
        

        this.setState({ flag: true, alert: 0, alertMessage: '' });

        await RestServices.forecBulkImportStoreOwners(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.status) {
                    this.setState({
                        flag: false,
                        alert: 2,
                        alertMessage: responseData.message
                    });
                } else {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: responseData.message
                    });
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    handleChangeWhatsappAlert = () => {
        if (this._isMounted) {
            this.setState({
                WhatsappAlertChecked: !this.state.WhatsappAlertChecked
            });
        }
    };

    cancelUplaodData = async (event) => {
        if (this._isMounted) {
            this.setState({
                storeFileUplaoded: false,
                alert: 0,
                StoreOwners: []
            });
        }
    };

    render() {
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                <Row style={{ padding: '0px 15px' }}>
                    <Col>
                        <span>Upload a sheet:</span>
                        <Tooltip title="Upload File">
                            <IconButton aria-label="upload">
                                <label>
                                    <CloudUploadIcon />
                                    <input
                                        type="file"
                                        hidden
                                        id="custom-file-translate"
                                        lang="en"
                                        accept=".xlsx, .xls"
                                        onChange={this.handleFileUploaded}
                                    />
                                </label>
                            </IconButton>
                        </Tooltip>
                    </Col>
                </Row>

                <Row style={{ padding: '0px 15px' }}>
                    <Col style={{ marginBottom: '1rem' }}>
                        <Button
                            style={{ marginTop: '1rem' }}
                            variant="info"
                            type="submit"
                            onClick={this.DownloadTemplate}
                        >
                            Download Template
                        </Button>
                    </Col>
                </Row>

                {this.state.alert === 3 && (
                    <Alert variant="warning">{this.state.alertMessage}</Alert>
                )}

                <Row style={{ padding: '0px 15px' }}>
                    <Col style={{ marginBottom: '1rem' }}>
                        <input
                            type="checkbox"
                            id="whatsapp_alert"
                            name="whatsapp_alert"
                            value="whatsapp_alert"
                            defaultChecked={this.state.WhatsappAlertChecked}
                            onChange={this.handleChangeWhatsappAlert}
                        />{' '}
                        Inform the StoreOwners about the StoreTag changes on
                        Whatsapp
                    </Col>
                </Row>

                <hr />
                <Form.Row>
                    {this.state.alert !== 3 && (
                        <Col>
                            <Button
                                variant="primary"
                                type="submit"
                                onClick={this.uplaodData}
                            >
                                Submit
                            </Button>
                        </Col>
                    )}

                    {this.state.alert === 3 && (
                        <Col>
                            <Button
                                variant="success"
                                type="submit"
                                onClick={this.forceuplaodData}
                            >
                                Changes Approved
                            </Button>
                            <Button
                                style={{ marginLeft: '1rem' }}
                                variant="danger"
                                type="submit"
                                onClick={this.cancelUplaodData}
                            >
                                Cancel the upload
                            </Button>
                        </Col>
                    )}
                </Form.Row>
            </Container>
        );
    }
}

export default ImportExport;
